module.exports = require("@bechtel/gds/dist/index.css");